import Vue from "vue";
import Router from "vue-router";

import Login from "./components/Login.vue";
import Home from "./components/Home.vue";
import Activities from "./components/adminSubmenues/Activities.vue";
import ActivityCategory from "./components/adminSubmenues/ActivityCategory.vue";
import ActivityMaster from "./components/adminSubmenues/ActivityMaster.vue";
import ActivityType from "./components/adminSubmenues/ActivityType.vue";
import AreaMaster from "./components/adminSubmenues/AreaMaster.vue";
import Cables from "./components/adminSubmenues/Cables.vue";
import ConfigurationMaster from "./components/adminSubmenues/ConfigurationMaster.vue";
import DPROutput from "./components/DPROutput.vue";
import Logos from "./components/Logos.vue";
import EquipmentStatus from "./components/adminSubmenues/EquipmentStatus.vue";
import ProgressAnalysis from "./components/adminSubmenues/ProgressAnalysis.vue";
import Estimates from "./components/adminSubmenues/Estimates.vue";
import MacroActivitiesMaster from "./components/adminSubmenues/MacroActivitiesMaster.vue";
import Project from "./components/adminSubmenues/Project.vue";
import ProtectionMethodology from "./components/adminSubmenues/ProtectionMethodology.vue";
import QHSEMaster from "./components/adminSubmenues/QHSEMaster.vue";
import Soil from "./components/adminSubmenues/Soil.vue";
import RankList from "./components/adminSubmenues/RankList.vue";
import Lines from "./components/adminSubmenues/Lines.vue";
import Tools from "./components/adminSubmenues/Tools.vue";
import Vessels from "./components/adminSubmenues/Vessels.vue";
import LocalComputerAssignment from "./components/LocalComputerAssignment.vue";
import ErrorLog from "./components/ErrorLog.vue";
import Users from "./components/Users.vue";
import UserProfile from "./components/UserProfile.vue";
import Translations from "./components/Translations.vue";
import PdfConfigurations from "./components/adminSubmenues/PdfConfigurations.vue";

//#region  DPR Related components
import DPRSearch from "./components/dprSubmenues/DPRSearch";
import DPRHeader from "./components/dprSubmenues/DPRHeader";
import ActWeather from "./components/dprSubmenues/ActWeather.vue";
import Status from "./components/dprSubmenues/Status.vue";
import Comments from "./components/dprSubmenues/Comments.vue";
import Lists from "./components/dprSubmenues/Lists.vue";
import SignOff from "./components/dprSubmenues/SignOff.vue";
//#endregion

Vue.use(Router);

export default new Router({
  //  base: UNUSED: WE NORMALLY SERVE THE APP FROM THE ROOT ("/")
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Home,
    },
    {
      path: "/local-computer-assignments",
      name: "localComputerAssignment",
      component: LocalComputerAssignment,
    },
    {
      path: "/admin/activity-configurations",
      name: "activities",
      component: Activities,
    },
    {
      path: "/admin/activity-categories",
      name: "activityCategory",
      component: ActivityCategory,
    },
    {
      path: "/admin/master-activities",
      name: "activityMaster",
      component: ActivityMaster,
    },
    {
      path: "/admin/master-areas",
      name: "areaMaster",
      component: AreaMaster,
    },
    {
      path: "/admin/cables",
      name: "cables",
      component: Cables,
    },
    {
      path: "/admin/master-configurations",
      name: "configMaster",
      component: ConfigurationMaster,
    },
    {
      path: "/dpr-output",
      name: "DPROutput",
      component: DPROutput,
    },
    {
      path: "/logos",
      name: "logos",
      component: Logos,
    },
    {
      path: "/users",
      name: "users",
      component: Users,
    },
    {
      path: "/user-profile",
      name: "userprofile",
      component: UserProfile,
    },
    {
      path: "/admin/progress-analysis",
      name: "progressAnalysis",
      component: ProgressAnalysis,
    },
    {
      path: "/admin/progress-analysis",
      name: "equipStatus",
      component: EquipmentStatus,
    },
    {
      path: "/admin/estimates",
      name: "estimates",
      component: Estimates,
    },
    {
      path: "/admin/master-macro-activities",
      name: "macroActMaster",
      component: MacroActivitiesMaster,
    },
    {
      path: "/admin/activity-types",
      name: "activityType",
      component: ActivityType,
    },
    {
      path: "/admin/projects",
      name: "project",
      component: Project,
    },
    {
      path: "/admin/protection-methodologies",
      name: "protectionMethodology",
      component: ProtectionMethodology,
    },
    {
      path: "/admin/master-qhses",
      name: "QHSEMaster",
      component: QHSEMaster,
    },
    {
      path: "/admin/soils",
      name: "soil",
      component: Soil,
    },
    {
      path: "/admin/rankList",
      name: "rankList",
      component: RankList,
    },
    {
      path: "/admin/lines",
      name: "lines",
      component: Lines,
    },
    {
      path: "/admin/tools",
      name: "tools",
      component: Tools,
    },
    {
      path: "/admin/vessels",
      name: "vessels",
      component: Vessels,
    },
    {
      path: "/error-logs",
      name: "errorLog",
      component: ErrorLog,
    },
    {
      path: "/translations",
      name: "translations",
      component: Translations,
    },

    //#region DPR related routes

    {
      path: "/dpr/search",
      name: "dprSearch",
      component: DPRSearch,
    },
    {
      path: "/dpr/:dprMainId/pv/:pvId/header",
      name: "dprHeader",
      component: DPRHeader,
    },
    {
      path: "/dpr/:dprMainId/pv/:pvId/activities-and-weather",
      name: "actWeather",
      component: ActWeather,
    },
    {
      path: "/dpr/:dprMainId/pv/:pvId/status",
      name: "status",
      component: Status,
    },
    {
      path: "/dpr/:dprMainId/pv/:pvId/comments",
      name: "comments",
      component: Comments,
    },
    {
      path: "/dpr/:dprMainId/pv/:pvId/lists",
      name: "lists",
      component: Lists,
    },
    {
      path: "/dpr/:dprMainId/pv/:pvId/sign-off",
      name: "signOff",
      component: SignOff,
    },
    {
      path: "/admin/pdf-configurations",
      name: "pdfConfigurations",
      component: PdfConfigurations,
    },

    //#endregion
  ],
});
